<template>
  <div class="reverse-info">
    <div class="text-right reverse-row reverseValue font-weight-700">
      剩余收货金额：{{ formatPrice(Number(poLeftAmount).toFixed(2)) }}元</div>
    <el-table :data="receiveDetailList" style="width: 100%" :header-cell-style="{
        background: '#E8E8E8'
      }" border>
      <!-- <el-table-column label="是否本次收货" align="center">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.isReceipt" :disabled="scope.row.detailStatus === 0"
            @change="handleReceiveAmount(scope.row)"></el-checkbox>
        </template>
      </el-table-column> -->
      <el-table-column prop="rowNumber" label="行项目号" align="center" />
      <el-table-column prop="itemCode" label="物料编码" align="center" />
      <el-table-column prop="itemName" label="物料名称" align="center" />
      <el-table-column prop="detailStatus" label="明细项状态" align="center" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.detailStatus === 1">有效</span>
          <span v-if="scope.row.detailStatus === 0">关闭</span>
        </template>
      </el-table-column>
      <el-table-column prop="itemAmount" label="总金额(元)" align="center">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.itemAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="grAmount" label="已收货金额(元)" align="center">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.grAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="实际收货金额" align="center" width="200px">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.receiveAmount" placeholder="请输入金额" :disabled="scope.row.detailStatus === 0"
            @input="handleReceiveAmount(scope.row)" type="number" :max="scope.row.itemAmount - scope.row.grAmount" :min="0">
            <template slot="append">元</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="最后一次收货" align="center">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.isLast" :disabled="scope.row.detailStatus === 0" @change="val=>openIsLastDialog(val,scope.$index)"></el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <!-- 审批按钮 -->
    <div class="operation_btn_box photo-bottom">
      <DialogPop @getRejectaccount="reject" :marLeft="true" isType="1" btnText="退回申请" centerText="是否确认退回申请？"
        :isReject="true">
      </DialogPop>
      <div class="operate_btn operate_btn_red" style="padding:0px 20px;" @click="openAgreeDialog">提交收货</div>
    </div>
    <!-- 提交收货弹窗 -->
    <el-dialog title="提示" :visible.sync="agreeDialog" :close-on-click-modal="false">
      <p style="color:black;" class="font-weight-700">
        <i class="el-icon-warning" style="font-size: 30px;color:orange"></i>
        本次申请收货金额
        <span class="color-red">{{ formatPrice(detailList.receiveAmount) }}</span>元，未收货金额
        <span class="color-red">{{ formatPrice(Number(poLeftAmount).toFixed(1)) }}</span>元，实际收货总金额
        <span class="color-red">{{ formatPrice(actualReceiveAmountAll) }}</span>元，是否确认提交收货？
      </p>
      <el-table :data="agreeTableData" style="width: 100%;" :header-cell-style="{
          background: '#E8E8E8'
        }" border>
        <el-table-column prop="rowNumber" label="行项目号" align="center" />
        <el-table-column prop="itemCode" label="物料编码" align="center" />
        <el-table-column prop="itemName" label="物料名称" align="center" />
        <el-table-column align="center" prop="receiveAmount" label="实际收货金额(元)">
          <template slot-scope="scope">
            {{ formatPrice(scope.row.receiveAmount) || 0 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isLast" label="最后一次收货">
          <template slot-scope="scope">
            <span v-if="scope.row.isLast" class="color-red font-weight-700">
              是
            </span>
            <span v-else>
              否
            </span>
          </template>
        </el-table-column>
      </el-table>
      <p class="color-red font-weight-700">注：最后一次收货的明细行之后不可再发起收货！</p>
      <div slot="footer" class="operation_btn_box">
        <div class="operate_btn operate_btn_white" @click="agreeDialog = false">取消</div>
        <div class="operate_btn operate_btn_red" @click="agree">确定</div>
      </div>
    </el-dialog>
    <!-- 确认最后一次收货弹窗 -->
    <el-dialog title="提示" :visible.sync="isLastDialog" top="30vh" :close-on-click-modal="false">
      <p style="color:black;" class="font-weight-700">
        <i class="el-icon-warning" style="font-size: 30px;color:orange"></i>
        选择最后一次收货将
        <span class="color-red">关闭此订单明细行</span>
        ，是否确定执行此操作
      </p>
      <div slot="footer" class="operation_btn_box">
        <div class="operate_btn operate_btn_white" @click="handleIsLastChange(false)">取消</div>
        <div class="operate_btn operate_btn_red"  @click="handleIsLastChange(true)">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DialogPop from "./dialog-pop.vue"
import gameplanApi from "@/api/gameplan"
import { create, all } from 'mathjs'
const math = create(all, {})
export default {
  name: 'ApprovalDetailPending',
  components: {
    DialogPop
  },
  props: {
    receiveDetailList: {
      type: Array,
      default: () => {
        return []
      }
    },
    detailList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actualReceiveAmountAll: 0,
      agreeDialog: false,
      agreeTableData: [],
      isLastDialog:false,
      selectedLast:{
        value:'',
        index:null
      }
    }
  },
  computed: {
    // 待审批-剩余收货金额
    poLeftAmount() {
      // 剩余收货金额 = 收货金额 - 勾选收货金额总和
      const receiveAmount = math.bignumber(this.detailList.receiveAmount || 0)
      const actualReceiveAmountAll = math.bignumber(this.actualReceiveAmountAll || 0)
      return math.number(math.subtract(receiveAmount,actualReceiveAmountAll))
    },
  },
  methods: {
    handleReceiveAmount(row) {
      const receiveAmountAll = this.receiveDetailList.reduce((pre, item) => {
        const receiveAmount = (typeof item.receiveAmount === 'number' && isFinite(item.receiveAmount)) ? item.receiveAmount : 0
        return math.number(math.add(math.bignumber(pre), math.bignumber(receiveAmount || 0)))
      }, 0)
      // console.log('实际收货金额总和：', receiveAmountAll)
      this.actualReceiveAmountAll = receiveAmountAll
    },
    // 驳回
    async reject(rejectAccount) {
      if (this.loading) return
      let params = {
        'receiveId': this.detailList.receiveId,
        'rejectReason': rejectAccount,
      };
      this.$emit('update:loading', true)
      const { data } = await gameplanApi.rejectPoReceive(params)
      if (data.resultCode === '0') {
        this.$message.success('收货审批已退回');
        this.$router.go(-1)
      } else {
        this.$message.error(data.resultMsg)
      }
      this.$emit('update:loading', false)
    },
    // 打开收货弹窗
    openAgreeDialog() {
      this.agreeTableData = this.receiveDetailList.filter(item => {
        return item.isLast || (typeof item.receiveAmount === 'number' && isFinite(item.receiveAmount))
      })
      if (!this.agreeTableData.length) {
        this.$message.error('请填写实际收货金额')
        return
      }
      const notNumlist = this.agreeTableData.filter(item => {
        if (item.isLast) {
          return (typeof item.receiveAmount !== 'number' || !isFinite(item.receiveAmount))
        }
      })
      if (notNumlist.length) {
        this.$message.error('请填写实际收货金额')
        return
      }
      const overflowReceiveAmount = this.agreeTableData.filter(item => {
        let itemAmount = math.bignumber(item.itemAmount)
        let grAmount = math.bignumber(item.grAmount)
        const maxReceiveAmount = math.number(math.subtract(itemAmount,grAmount))
        const receiveAmount = math.number(item.receiveAmount)
        return math.larger(receiveAmount,maxReceiveAmount)
      })
      if(overflowReceiveAmount.length){
        this.$message.error(`行项目号 ${
          overflowReceiveAmount.map(item=>{
            return item.rowNumber
          }).join(',')
        } 实际收货金额合计超出剩余可收货金额，请确认后重新填写`)
        return
      }
      if (this.poLeftAmount < 0) {
        this.$message.error('实际收货金额合计超出本次收货金额，请确认后重新填写')
        return
      }
      this.agreeDialog = true
      console.log(this.agreeTableData)
    },
    // 通过
    async agree() {
      if (this.loading) return
      let params = {
        'receiveId': this.detailList.receiveId,
        'receiveDetailList': (() => {
          return this.agreeTableData.map(item => {
            return {
              receiveAmount: item.receiveAmount || 0,
              rowNumber: item.rowNumber,
              isLast: item.isLast ? 1 : 0,
            }
          })
        })(),
      }
      if (this.poLeftAmount < 0) {
        this.$message.error('实际收货金额合计超出本次收货金额，请确认后重新填写')
      } else {
        this.$emit('update:loading', true)
        this.agreeDialog = false
        const { data } = await gameplanApi.approvePoReceive(params);
        if (data.resultCode === '0') {
          // this.menuCode = '02'
          // this.init()
          this.$message.success('收货审批已通过');
          this.$router.go(-1)
        } else {
          this.$message.error(data.resultMsg)
        }
        this.$emit('update:loading', false)
      }
    },
    // 金额千分
    formatPrice(price) {
      return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 打开最后一次收货弹窗
    openIsLastDialog(val,index){
      if(val === true){
        this.isLastDialog = true
        this.selectedLast = {
          value : val,
          index:index
        }
      }
    },
    // 取消最后一次收货弹窗
    handleIsLastChange(bool){
      if(bool){
        this.isLastDialog = false
      }else{
        this.receiveDetailList[this.selectedLast.index].isLast = false
        this.isLastDialog = false
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.operation_btn_box {
  width: 100%;
  display: flex;
  justify-content: center;
  // margin: -30px 0 10px 0;

}

.operate_btn {
  display: inline-block;
  text-align: center;
  padding: 5px 20px;
  border-radius: 4px;
  margin: 0px 0 0 10px;
  cursor: pointer;
}

.operate_btn_red {
  color: white;
  background-color: rgb(214, 0, 0);
}

.operate_btn_white {
  color: rgb(214, 0, 0);
  background-color: white;
  border: 1px solid rgb(214, 0, 0);
}

.color-red {
  color: $base-red;
}

.photo-bottom {
  margin-top: 100px;
  // align-items: center;
  // height: 40px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
}

.reverse-info {
  .reverse-create {
    text-align: right;
    padding: 10px 5px 0 0;
  }

  .reverse-row {
    line-height: 24px;
    margin-bottom: 3px;
    padding: 10px;
  }

  .reverseValue {
    color: #cd1231;
  }
}

::v-deep .el-dialog {
  margin: 0 auto 15px;
}

::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 70vh;
  padding: 0px 20px
}

::v-deep .el-dialog__footer {
  padding: 10px !important;
}

</style>
